import { en } from './en'
import { fr } from './fr'

export const landingPageForNonprofits = {
  en,
  fr
}